<template>
  <v-container fluid fill-height class="d-flex">
    <v-layout justify-center align-start>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="br-10 pa-4 text-center">
            <span class="title pb-3"><strong>{{ $t('complaint_history') }}</strong></span>
            <v-data-iterator content-tag="v-layout" row wrap :items="list" :items-per-page="10">
              <v-flex slot="item" slot-scope="props">
                <v-card class="elevation-0">
                  <v-card-title @click="$router.push('/complaint/detail/' + props.item._id)">
                    <span class="body-2 font-weight-bold">{{ props.item.date | dateTime }}</span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-list dense>
                    <v-list-item @click="$router.push('/complaint/detail/' + props.item._id)">
                      <v-list-item-content style="width: 50%">{{ $t('complaint_no') }}:</v-list-item-content>
                      <v-list-item-content style="width: 50%" class="font-weight-bold primary--text">{{ props.item._id }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content style="width: 50%">{{ $t('status') }}:</v-list-item-content>
                      <v-list-item-content style="width: 50%" class="font-weight-bold">{{ $t(props.item.status) }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content style="width: 50%">{{ $t('category') }}:</v-list-item-content>
                      <v-list-item-content style="width: 50%" class="font-weight-bold">{{ $t(props.item.category) | capitalize }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content style="width: 50%">{{ $t('description') }}:</v-list-item-content>
                      <v-list-item-content style="width: 50%" class="font-weight-bold">{{ props.item.description | capitalize }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content style="width: 50%">{{ $t('location') }}:</v-list-item-content>
                      <v-list-item-content style="width: 50%" class="font-weight-bold">{{ props.item.location | capitalize }}</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-flex>
            </v-data-iterator>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
export default {
  computed: {
    ...vuex.mapState({
      list: state => state.complaint.list,
      iterator: state => state.complaint.iterator
    })
  },
  created: function () {
    const fetchSession = this.$store.dispatch('auth/session')
    fetchSession.then(function (response) {
      if (response.userCtx.name === '' || response.userCtx.name === 'couchdb') {
        this.$router.push('/')
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: 'Pengguna tidak dijumpai. Sila log masuk semula.',
          visible: true
        })
      }
      this.$store.dispatch('complaint/fetchList')
    }.bind(this))
  },
  methods: {
    ...vuex.mapActions({
      fetchList: 'complaint/fetchList'
    })
  }
}
</script>
